import React, { useState, useEffect, useCallback } from "react";
import SearchBar from "./SearchBar";
import { defaultGridProps } from "../../../components/AuiGrid/gridLayout";
import ButtonBar from "../../../components/Layout/ButtonBar";
import { useAxiosWithAuthorization } from "../../../utils/api";
import { ModalConfirm } from "../../../components/Confirm";
import useAuiGridMethods from "../../../hooks/AuiGrid/useAuiGridMethods";
import {
  createGroupColumnData,
  createUserColumnData,
  createGroupUserColumnData,
} from "./conlumnLayout";

import { useId } from "react-id-generator";
import { saveGridCheckData } from "../../../utils/validators";

const GroupUserMng = (props) => {
  const [authGrid] = useId(1, "aui-grid-");
  const [authGroupGrid] = useId(1, "aui-grid-");
  const [groupGrid] = useId(1, "aui-grid-");

  let auiGroupGrid = useAuiGridMethods(authGrid);
  let auiGroupUserGrid = useAuiGridMethods(authGroupGrid);
  let auiUserGrid = useAuiGridMethods(groupGrid);

  //그리드 초기 설정
  useEffect(() => {
    auiGroupGrid.create(createGroupColumnData(), {
      ...defaultGridProps,
    });
    auiGroupUserGrid.create(createGroupUserColumnData(), {
      ...defaultGridProps,
    });
    auiUserGrid.create(createUserColumnData(), {
      ...defaultGridProps,
    });

    auiGroupGrid.bind("cellClick", function (event) {
      searchGroupUserList(event.item.groupId);
    });
    // hidden 컬럼 정의
    auiGroupUserGrid.hideColumnByDataField("mastCd");
    // 에디팅 시작 이벤트 바인딩
    auiGroupGrid.bind("cellEditBegin", function (event) {
      // 추가된 행 아이템들(배열)은 수정이 가능해야

      if (auiGroupGrid.isAddedById(event.item._$uid)) {
        return true;
      }
      // 마스터 그리드의 마스터코드 편집 불가능
      if (event.dataField === "mastCd") {
        return false;
      }
    });

    // 에디팅 시작 이벤트 바인딩
    auiGroupUserGrid.bind("cellEditBegin", function (event) {
      // 추가된 행 아이템들(배열)은 수정이 가능해야
      if (auiGroupUserGrid.isAddedById(event.item._$uid)) {
        return true;
      }
      // 디테일 그리드의 디테일코드 편집 불가능
      if (event.dataField === "detailCd") {
        return false;
      }
    });
  }, []);

  const [primaryParameters, setPrimaryParameters] = useState({
    schGroupNm: "",
  });

  //그룹정보 검색 URL
  const SERARCH_GROUP_URL = "/common/group/searchGroupList.do";

  //그룹별사용자정보 검색 URL
  const SERARCH_GROUP_USER_URL = "/common/group/searchGroupUserList.do";
  //그룹별사용자정보 저장 URL
  const SAVE_GROUP_USER_URL = "/common/group/saveGroupUserList.do";
  //그룹별사용자정보 삭제 URL
  const DELETE_GROUP_USER_URL = "/common/group/deleteGroupUserList.do";

  //사용자정보 검색 URL
  const SERARCH_USER_URL = "/common/group/searchUserList.do";

  const [, fetchData] = useAxiosWithAuthorization(
    {
      url: SERARCH_GROUP_URL,
    },
    { manual: true }
  );

  const [userFieldValues, setUserFieldValues] = useState({
    schUserId: "",
    schUserNm: "",
  });

  const handleUserSearch = async () => {
    const {
      data: { data },
    } = await fetchData({
      url: SERARCH_USER_URL,
      params: userFieldValues,
    });

    auiUserGrid.setGridData(data);
  };

  const handleMasterSearch = async () => {
    const {
      data: { data },
    } = await fetchData({
      url: SERARCH_GROUP_URL,
      params: primaryParameters,
    });
    auiGroupGrid.setGridData(data);
  };

  const searchGroupUserList = async (groupId) => {
    const {
      data: { data },
    } = await fetchData({
      url: SERARCH_GROUP_USER_URL,
      params: { schGroupId: groupId },
    });

    auiGroupUserGrid.setGridData(data);
  };

  const handleMasterDelete = async () => {
    auiGroupUserGrid.removeRow("selectedIndex");
  };
  const handleMasterSave = async () => {
    if (
      await ModalConfirm({
        title: "저장",
        description: "데이터를 저장하시겠습니까?",
      })
    ) {
      const addItems = auiGroupUserGrid.getAddedRowItems();
      const editItems = auiGroupUserGrid.getEditedRowItems();
      const removeItems = auiGroupUserGrid.getRemovedItems();

      let param = saveGridCheckData(addItems, editItems, removeItems);

      const {
        data: { data },
      } = await fetchData({
        url: SAVE_GROUP_USER_URL,
        data: param,
        method: "POST",
      });

      const groupItem = auiGroupGrid.getSelectedItems()[0].item;

      searchGroupUserList(groupItem.groupId);
    }
  };

  //권한별메뉴 그리드에 검색한 메뉴 추가
  const handleGroupUserAdd = () => {
    const userItem = auiUserGrid.getSelectedItems()[0].item;
    //console.log(userItem);
    const groupItem = auiGroupGrid.getSelectedItems()[0].item;
    //console.log(groupItem);

    var rows = auiGroupUserGrid.getRowsByValue("userId", userItem.userId);
    //console.log(rows);
    if (rows.length > 0) {
      ModalConfirm({
        title: "사용자존재",
        description:
          "선택한 사용자는 그리드에 있습니다. 다시 선택하시기 바랍니다. ",
        type: "alert",
      });
    } else {
      userItem.groupId = groupItem.groupId;
      auiGroupUserGrid.addRow(userItem, "last");
    }
  };

  //메뉴검색 항목이 변경될때 사용되는 함수
  const handleUserChangeField = useCallback((event) => {
    const { name, value } = event.target;

    setUserFieldValues({ ...userFieldValues, [name]: value });
  });

  return (
    <>
      <ButtonBar
        menuInfo={props.menuInfo}
        handleMasterSearch={handleMasterSearch}
        handleMasterDelete={handleMasterDelete}
        handleMasterSave={handleMasterSave}
      />
      <SearchBar setSearchParameters={setPrimaryParameters} />

      <div className="flexible_contents_box2">
        <div className="databox" style={{ width: "100%", height: "100%" }}>
          <div className="scrollbox">
            <div style={{ width: "100%", height: "100%" }}>
              <div id={authGrid} style={{ width: "100%", height: 600 }} />
            </div>
          </div>
        </div>
        <div className="databox">
          <div className="subdatabox">
            <div id={authGroupGrid} style={{ height: 300 }} />
            <div className="searchdata">
              <ul className="displays">
                <li style={{ width: "180px" }}>
                  <div style={{ width: "80px" }}>
                    <font color="grey">⦁</font> 사용자아이디
                  </div>
                  <input
                    type="text"
                    className="datainput"
                    name="schUserId"
                    style={{ width: "100px" }}
                    onChange={handleUserChangeField}
                  />
                </li>
                <li style={{ width: "160px" }}>
                  <div style={{ width: "80px" }}>
                    <font color="grey">⦁</font> 사용자명
                  </div>
                  <input
                    type="text"
                    className="datainput"
                    name="schUserNmKor"
                    style={{ width: "100px" }}
                    onChange={handleUserChangeField}
                  />
                </li>
                <li style={{ width: "150px" }}>
                  <button
                    type="button"
                    className="btn_orenge updown0"
                    onClick={handleUserSearch}
                  >
                    검색
                  </button>
                  <button
                    type="button"
                    className="btn_orenge updown0"
                    onClick={handleGroupUserAdd}
                  >
                    추가
                  </button>
                </li>
              </ul>
            </div>
            <div id={groupGrid} style={{ height: 250 }} />
          </div>
        </div>
      </div>
    </>
  );
};

export default GroupUserMng;
